var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BModal,{attrs:{"active":_setup.isModalOpen,"custom-class":"youtube-modal"},on:{"close":_setup.closeModal}},[_c(_setup.YoutubeIframe,{attrs:{"video-id":_setup.videoId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }